// Lightweight entrance wrapper. Uses a pure-CSS animation that always plays on
// mount, so content can never get stuck hidden (no IntersectionObserver needed).
export function Reveal({ children, delay = 0, className = "" }) {
  return (
    <div className={`reveal-anim ${className}`} style={{ animationDelay: `${delay}ms` }}>
      {children}
    </div>
  );
}
